/// <amd-module name="Agile/ArtifactPicker/Components/AgileArtifactPickListCallout" />
import * as React from "react";
import { WrappedComponent } from "VSS/Platform/Layout";
import { Callout, ICalloutProps } from "VSSUI/Callout";
import { IPickListProps } from "VSSUI/Components/PickList";
import { FocusZone } from "VSSUI/FocusZone";
import { css } from "VSSUI/Util";
import { Location } from "VSSUI/Utilities/Position";

interface IAgileArtifactPickListCalloutProps {
    pickListClassName: string;
    anchorElement?: HTMLElement;
    onDismiss: () => void;

    // optional props for callout and picklist
    calloutProps?: ICalloutProps;
    picklistProps?: IPickListProps;
}

export class AgileArtifactPickListCallout extends React.Component<IAgileArtifactPickListCalloutProps> {
    public static defaultProps = {
        calloutProps: {
            anchorOrigin: { horizontal: Location.start, vertical: Location.end },
            calloutOrigin: { horizontal: Location.start, vertical: Location.start },
            escDismiss: true,
            lightDismiss: true,
            blurDismiss: true,
            contentShadow: true
        }
    };

    public render(): JSX.Element | null {
        const { pickListClassName, onDismiss, anchorElement, calloutProps, picklistProps } = this.props;

        return (
            <Callout {...calloutProps} onDismiss={onDismiss} anchorElement={anchorElement}>
                <FocusZone
                    circularNavigation={true}
                    defaultActiveElement={".agile-artifact-picklist-focus-element"}
                    focusOnMount={true}
                    handleTabKey={true}
                    includeDefaults={true}
                >
                    <div className={"agile-artifact-picklist-focus-element"} tabIndex={-1}>
                        <WrappedComponent
                            dependencies={["ms.vss-features.ui-picklist-content"]}
                            wrappedType={"picklist"}
                            {...picklistProps}
                            className={css("agile-artifact-pickList", pickListClassName)}
                        />
                    </div>
                </FocusZone>
            </Callout>
        );
    }
}
